import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { TWO_A_URL } from "./EstimateCTA";

export const Footer = () => {
  return (
    <footer className="border-t border-black/10 bg-[#F5F5F7]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-12 md:py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <p className="font-display text-xl font-extrabold tracking-tight text-navy">
              SELL MY PHONE <span className="text-brand">CHICAGO</span>
            </p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#4A4A4A]">
              Chicago's educational resource for electronics buyback. Sell eligible working phones, laptops,
              tablets, watches, and consoles — prepared properly, evaluated transparently, paid quickly.
            </p>
            <p className="mt-5 max-w-sm rounded-xl border border-black/10 bg-white p-4 text-xs leading-relaxed text-[#4A4A4A]" data-testid="footer-disclosure">
              Sell My Phone Chicago is operated in association with{" "}
              <a href="https://2aelectronics.com/" target="_blank" rel="noopener" className="font-semibold text-navy underline underline-offset-2 hover:text-brand">
                2A Electronics
              </a>
              , a Chicago electronics business.
            </p>
          </div>
          <div className="md:col-span-2">
            <p className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-[#8A8A8A]">Sell</p>
            <ul className="flex flex-col gap-2.5 text-sm">
              {[["Phone", "/sell-your-phone"], ["Laptop", "/sell-your-laptop"], ["Tablet", "/sell-your-tablet"], ["Smartwatch", "/sell-your-smartwatch"], ["Console", "/sell-your-gaming-console"], ["Sealed", "/sell-sealed-electronics"]].map(([l, to]) => (
                <li key={to}><Link to={to} className="text-black/70 transition-colors hover:text-brand">{l}</Link></li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-[#8A8A8A]">Learn</p>
            <ul className="flex flex-col gap-2.5 text-sm">
              {[["Buyback Guides", "/guides"], ["How It Works", "/how-it-works"], ["Prepare Your Device", "/prepare-your-device"], ["Data Privacy", "/data-privacy"], ["Chicago Guide", "/chicago-buyback-guide"]].map(([l, to]) => (
                <li key={to}><Link to={to} className="text-black/70 transition-colors hover:text-brand">{l}</Link></li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-[#8A8A8A]">Get started</p>
            <p className="text-sm leading-relaxed text-[#4A4A4A]">Working device in good condition? Get an indicative range in under a minute.</p>
            <a href={TWO_A_URL} target="_blank" rel="noopener" data-testid="footer-estimate-btn"
              className="group mt-5 inline-flex items-center gap-2 rounded-full bg-navy px-6 py-3 font-display text-xs font-bold uppercase tracking-[0.15em] text-white transition-colors hover:bg-brand">
              Get a Buyback Estimate
              <ArrowUpRight size={14} weight="bold" className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t border-black/10 pt-8 text-xs text-[#8A8A8A] md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} Sell My Phone Chicago. We purchase eligible working electronics in good condition. We do not buy broken devices.</p>
          <div className="flex gap-6">
            <Link to="/about" className="transition-colors hover:text-brand">About</Link>
            <Link to="/contact" className="transition-colors hover:text-brand">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
